// apps/spa/src/components/commands/EmptyState.tsx
// Empty state for the /commands list (no slash commands configured yet).
//
// Per CONTEXT spec:
//   Heading: 'No slash commands yet' (Fraunces font-display)
//   Caption: 'Create your first command for BASTN.'
//   CTA: '+ New command' Link to /commands/new

import { Link } from 'react-router';
import { motion, useReducedMotion } from 'motion/react';
import { Button } from '@/components/ui/button';
import { fadeUp } from '@/lib/motion';

export function CommandsEmptyState() {
  const reduce = useReducedMotion();
  return (
    <motion.div
      variants={fadeUp}
      initial={reduce ? false : 'hidden'}
      animate="show"
      className="flex flex-col items-center justify-center gap-4 py-16 text-center"
    >
      <span className="relative inline-flex">
        <span
          aria-hidden="true"
          className="absolute inset-0 -z-10 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(212,175,55,.25), transparent 70%)',
            animation: reduce ? undefined : 'ringBreath 4s ease-in-out infinite',
          }}
        />
        <svg
          aria-hidden="true"
          viewBox="0 0 64 64"
          className="size-16"
          role="img"
        >
          {/* Terminal prompt mark — represents a slash command */}
          <path
            d="M8 20 L8 44 Q8 52 16 52 L48 52 Q56 52 56 44 L56 20 Q56 12 48 12 L16 12 Q8 12 8 20 Z"
            fill="none"
            stroke="#d4af37"
            strokeWidth="2"
          />
          <path
            d="M16 26 L24 32 L16 38"
            stroke="#d4af37"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 38 L40 38"
            stroke="#d4af37"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <h2 className="font-display text-2xl">No slash commands yet</h2>
      <p className="text-muted-foreground max-w-md text-sm">
        Create your first command for BASTN.
      </p>
      <Link to="/commands/new">
        <Button>+ New command</Button>
      </Link>
    </motion.div>
  );
}
